import React from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { blogs } from '../../blogsData';
import BlogPost from './BlogPost';

const BlogRoute: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();
  // Case-insensitive slug match so /blogs/apiary, /blogs/Apiary, /blogs/APIARY
  // all resolve to the same post. Useful for old links that may have been
  // shared with different casing.
  const normalized = slug?.toLowerCase();
  const blog = blogs.find(b => b.slug.toLowerCase() === normalized);

  if (!blog) {
    return <Navigate to="/blogs" replace />;
  }

  // Canonicalize the URL: if the visitor came in with a different casing
  // (e.g. /blogs/Apiary), redirect them to the lowercase slug so the
  // address bar matches the canonical link.
  if (slug !== blog.slug) {
    return <Navigate to={`/blogs/${blog.slug}`} replace />;
  }

  return <BlogPost blog={blog} onClose={() => navigate('/blogs')} />;
};

export default BlogRoute;
